import axios from "@axios";

const DEFAULT_STATE = {
  groups: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getGroups: (state) => state.groups,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setGroups(state, payload) {
      state.groups = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateGroups({ commit }, payload) {
      commit("setGroups", payload);
    },
    async getGroups({ commit }) {
      const {
        data: { items },
      } = await axios.get("/adb_videos_list_groups/", {
        params: {
          //sort_by: "name"
        },
      });
      const results = items.map((item) => ({
        ...item,
        text: `${item["id"]} - ${item["name"]}`,
      }));
      commit("setGroups", results);

      return results;
    },
  },
};
